import { Typography as MUITypography } from "@mui/material";
import ThemeContext from "components/app/Context";
import { useContext } from "react";

interface Props {
  showBold?: boolean;
  color?: string;
  sx?: object;
  children: any;
  variant?: any;
  component?: any;
  textAlign?: any;
  changeVariant?: boolean;
  onClick?: (args: any) => void;
  className?: string;
}

const typographyVariants = (variant: string) => {
  switch (variant) {
    case "h2": {
      return "h3";
    }
    case "h3": {
      return "h4";
    }
    case "h4": {
      return "h5";
    }
    case "h5": {
      return "body1";
    }
    case "body1": {
      return "body2";
    }
    case "body2": {
      return "body2";
    }
    case "label": {
      return "label";
    }
    default: {
      return variant;
    }
  }
};
function Typography(props: Props) {
  const {
    showBold = false,
    color,
    variant,
    component,
    textAlign,
    changeVariant = true,
    sx,
    onClick,
    className = ""
  } = props;
  const { isMobileScreen } = useContext(ThemeContext);

  return (
    <MUITypography
      component={component}
      variant={isMobileScreen && changeVariant ? typographyVariants(variant) : variant}
      sx={{ color: color, fontWeight: showBold ? 700 : 400, textAlign: { textAlign }, ...sx }}
      onClick={onClick}
      className={className}
    >
      {props.children}
    </MUITypography>
  );
}

export default Typography;
